export default __webpack_public_path__ + "static/media/SIP_template.f6d3f5d1.png";